import { Box } from "@chakra-ui/layout";
import Container from "components/Container";
import PageHeader from "components/Page/PageHeader";
import { OperacaoEnum } from "core/resources/enums/conta";
import { useRef } from "react";
import TableContaRecorrente from "./components/TableContaRecorrente/index";
import useFiltroContaRecorrente from "./hooks/useFiltroContaRecorrente";
import { Flex } from "@chakra-ui/react";
import SelectMonthYear from "ui/components/Input/SelectMonthYear";
import moment from "moment";

interface ContaRecorrentePageProps {
  operacao: OperacaoEnum;
}

function ContaRecorrenteContent({ operacao }: ContaRecorrentePageProps) {
  const { filtro, onChangeFiltro } = useFiltroContaRecorrente(operacao);

  const modalFormRef = useRef<{
    openModalContaRecorrente: () => {};
    closeModalContaRecorrente: () => {};
  } | null>(null);

  return (
    <>
      <Container>
        <PageHeader
          title={
            operacao === OperacaoEnum.Receita
              ? "Receitas recorrentes"
              : "Despesas recorrentes"
          }
          midComponent={
            <Flex>
              <SelectMonthYear
                bg="white"
                value={moment(filtro.mes, "YYYY-MM")}
                onChange={(date) =>
                  onChangeFiltro({ mes: date?.format("YYYY-MM") })
                }
              />
            </Flex>
          }
          titleButton={`Cadastrar ${
            operacao === OperacaoEnum.Receita ? "receita" : "despesa"
          } recorrente`}
          onClick={() => modalFormRef.current?.openModalContaRecorrente()}
        />

        <Box mt="32px">
          <TableContaRecorrente
            filtro={filtro}
            operacao={operacao}
            onChangeFiltro={onChangeFiltro}
            ref={modalFormRef}
          />
        </Box>
      </Container>
    </>
  );
}

export function ContaRecorrenteContentReceita() {
  return <ContaRecorrenteContent operacao={OperacaoEnum.Receita} />;
}

export function ContaRecorrenteContentDespesa() {
  return <ContaRecorrenteContent operacao={OperacaoEnum.Despesa} />;
}

export default ContaRecorrenteContent;
